import { Injectable } from '@angular/core'

import { HttpService } from './http.service'

import { CreateMenuDto, FindMenuDto, MenuDto, PageResultDto } from '../dto'

@Injectable()
export class AdminMenuService {
  constructor(
    private httpService: HttpService) {
  }

  async find(findMenuDto: FindMenuDto) {
    return await this.httpService.get<PageResultDto<MenuDto>>('/admin/v1/menu', findMenuDto)
  }

  async update(id: string, updateMenuDto: CreateMenuDto) {
    return await this.httpService.put<Boolean>(`/admin/v1/menu/${id}`, updateMenuDto)
  }

  async sortOrder(ids: string[]) {
    return await this.httpService.put<Boolean>(`/admin/v1/menu/sort-order`, { ids })
  }

  async create(createMenuDto: CreateMenuDto) {
    return await this.httpService.post<Boolean>(`/admin/v1/menu`, createMenuDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`/admin/v1/menu/${id}`)
  }

  async setEnable(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.patch<Boolean>(`/admin/v1/menu/${id}/enable`)
    }

    return await this.httpService.patch<Boolean>(`/admin/v1/menu/${id}/disable`)
  }
}
